import React, { useState } from "react";
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
import ReCAPTCHA from "react-google-recaptcha";
import {
  Error,
  required,
  isEmail,
  minLen,
  composeValidators,
} from "../Payment/Shared";
import axios from "../../api/axios";

function Contact() {
  const recaptchaRef = React.createRef();

  const [formSubmitting, setFormSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  return (
    <div>
      <h1 className="white">Feedback</h1>
      <div className="panel">
        <div className="contact_content row">
          <section className="contact_form__wrapper small-12 medium-10 medium-push-1 large-8 large-push-2 columns">
            {showSuccess && (
              <div className="validation">
                <div className="alert-box success">
                  Thank you for your feedback
                </div>
              </div>
            )}
            <Form
              action="https://www.afes.docksal/contact"
              method="post"
              acceptCharset="utf-8"
              id="contact_form"
              data-reset="1"
              className="contact"
              novalidate="novalidate"
              onSubmit={(values) => console.log(values)}
            >
              {({ handleSubmit, submitting, values, form, ...rest }) => {
                const submitForm = (e) => {
                  if (rest.hasValidationErrors) {
                    setFormSubmitting(false);
                    e.preventDefault();
                    form.submit();

                    return false;
                  }

                  setSubmitError(false);
                  setFormSubmitting(true);
                  recaptchaRef.current.reset();
                  recaptchaRef.current.execute();
                };

                const processCaptchaResponse = async (value) => {
                  if (value === null) {
                    recaptchaRef.current.reset();
                    recaptchaRef.current.execute();
                    setFormSubmitting(false);
                    return;
                  }

                  if (rest.hasValidationErrors) {
                    setFormSubmitting(false);
                    return rest.errors;
                  }

                  try {
                    await axios.post("api/contact", {
                      "g-recaptcha-response": value,

                      ...values,
                    });

                    setShowSuccess(true);
                    setFormSubmitting(false);
                    form.resetFieldState("name");
                    form.resetFieldState("email");
                    form.resetFieldState("message");
                    form.reset();
                  } catch (error) {
                    setFormSubmitting(false);
                    setSubmitError("Failed to send, please try again");
                    return { [FORM_ERROR]: "Failed to send, please try again" };
                  }
                };

                return (
                  <form onSubmit={submitForm}>
                    <ReCAPTCHA
                      onChange={processCaptchaResponse}
                      ref={recaptchaRef}
                      sitekey="6Lc7RCMUAAAAAGT3GlE3QXMzwuThsImOPvsdzGsz"
                      size="invisible"
                    />
                    <div className="form_row">
                      <div className="form_column form_column--2-3">
                        <label className="form_label">
                          <label htmlFor="name">Name</label>
                        </label>
                        <Field name="name" validate={required}>
                          {({ input }) => (
                            <input
                              className="form_input"
                              type="text"
                              id="name"
                              name="name"
                              maxLength="255"
                              {...input}
                            />
                          )}
                        </Field>
                        <Error name="name" />
                      </div>
                    </div>

                    <div className="form_row">
                      <div className="form_column form_column--2-3">
                        <label className="form_label">
                          <label htmlFor="email">Email</label>
                        </label>
                        <Field
                          name="email"
                          validate={composeValidators(required, isEmail)}
                        >
                          {({ input }) => (
                            <input
                              className="form_input"
                              type="email"
                              id="email"
                              name="email"
                              maxLength="255"
                              {...input}
                            />
                          )}
                        </Field>
                        <Error name="email" />
                      </div>
                    </div>

                    <div className="form_row">
                      <div className="form_column">
                        <label className="form_label">
                          <label htmlFor="message">Message</label>
                        </label>
                        <Field
                          name="message"
                          validate={composeValidators(required, minLen(20))}
                        >
                          {({ input }) => (
                            <textarea
                              className="form_input"
                              id="message"
                              name="message"
                              aria-required="true"
                              {...input}
                            />
                          )}
                        </Field>
                        <Error name="message" />
                      </div>
                    </div>

                    <div
                      className="contact_form__validation validation"
                      htmlFor="contact_form"
                    />

                    <div className="contact_form__button form_foot ">
                      <div className="right_aligned">
                        <div className="validation">
                          {submitError && (
                            <div className="alert-box alert">{submitError}</div>
                          )}
                        </div>
                        <button
                          className="contact_form__submit g-recaptcha btn_pri btn_pri--last"
                          disabled={formSubmitting}
                          type="submit"
                          onClick={submitForm}
                        >
                          {formSubmitting ? "Submitting" : "Send Message"}
                        </button>
                      </div>
                    </div>
                  </form>
                );
              }}
            </Form>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Contact;
